import { RefreshCw } from "lucide-react";
import { useNewVersionCheck } from "@/hooks/useNewVersionCheck";
import { Button } from "@/components/ui/button";

export function NewVersionBanner() {
  const newVersionAvailable = useNewVersionCheck();

  if (!newVersionAvailable) return null;

  return (
    <div className="fixed bottom-4 left-1/2 z-50 -translate-x-1/2 animate-in fade-in slide-in-from-bottom-4 duration-300">
      <div className="flex items-center gap-3 rounded-lg border border-primary/30 bg-background px-4 py-3 shadow-lg">
        <RefreshCw className="h-4 w-4 text-primary" />
        <span className="text-sm">A new version is available.</span>
        <Button size="sm" onClick={() => window.location.reload()}>
          Refresh
        </Button>
      </div>
    </div>
  );
}
